/**
 * @generated SignedSource<<1d1a2854c664c4161ce73cfe3e4c0a6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ImageVersionTypeName = "bgProcessed" | "datamatics" | "large" | "master" | "medium" | "oldMaster" | "original" | "placeholder" | "small" | "thumb" | "transparent" | "zoom" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpHeadDeprecated_item$data = {
  readonly isPriceUponRequest: boolean | null;
  readonly localizedPdpUrl: string | null;
  readonly microdata: string | null;
  readonly pdpMeta: {
    readonly description: string | null;
    readonly index: boolean | null;
    readonly ogTitle: string | null;
    readonly productPriceAmount: string | null;
    readonly productPriceCurrency: string | null;
    readonly title: string | null;
  } | null;
  readonly pdpURL: string | null;
  readonly photos: ReadonlyArray<{
    readonly versions: ReadonlyArray<{
      readonly type: {
        readonly name: ImageVersionTypeName | null;
      } | null;
      readonly webPath: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "PdpHeadDeprecated_item";
};
export type PdpHeadDeprecated_item$key = {
  readonly " $data"?: PdpHeadDeprecated_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpHeadDeprecated_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "forcedCurrency"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpHeadDeprecated_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "currency",
          "variableName": "forcedCurrency"
        }
      ],
      "kind": "ScalarField",
      "name": "microdata",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdpURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "pdpMetaItems",
      "kind": "LinkedField",
      "name": "pdpMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "index",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ogTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productPriceAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productPriceCurrency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageVersionType",
              "kind": "LinkedField",
              "name": "type",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPriceUponRequest",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "bb0120d405494d2ff7a2361b49502fd8";

export default node;
